import type { InjectionKey } from 'vue';

export const FORM_ITEM_INJECTION_KEY = Symbol('injection-key') as InjectionKey<string>;
